import {
  useListActiveParticipantFeesByCongressIdQuery,
  useListParticipantFeesByCongressIdQuery,
} from "../store/fee/fee";
import { Fee } from "../types/fee.types";

interface UseParticipantFeesQueryResult {
  fees: Fee[];
  areParticipantFeesLoading: boolean;
}

export const useParticipantFeesQuery = (
  congressId: number,
  isEditMode: boolean
): UseParticipantFeesQueryResult => {
  const feesPublicQuery = useListActiveParticipantFeesByCongressIdQuery(
    congressId,
    {
      skip: isEditMode,
    }
  );
  const feesHiddenQuery = useListParticipantFeesByCongressIdQuery(congressId, {
    skip: !isEditMode,
  });

  const fees = isEditMode
    ? feesHiddenQuery.data ?? []
    : feesPublicQuery.data ?? [];
  const areParticipantFeesLoading = isEditMode
    ? feesHiddenQuery.isLoading
    : feesPublicQuery.isLoading;

  return {
    fees,
    areParticipantFeesLoading,
  };
};
